import '~/env'
import elementClosest from 'element-closest'
import Vue from 'vue'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import PortalVue from 'portal-vue'
import Router from '~/router'
import Store from '~/store'
import AuthService from 'services/AuthService'
import SessionActivityService from 'services/SessionActivityService'
import I18n from '~/i18n'
import 'mixins/CommonMixin'
import '~/axios'
import '~/native'
import '~/sentry'
import Meta from 'vue-meta'
import VueApexCharts from 'vue-apexcharts'
import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css'
import './registerServiceWorker'
import VueConfetti from 'vue-confetti'
import { Amplify } from 'aws-amplify'
import { Userpilot } from 'userpilot'

Amplify.configure({
    Auth: {
        region: process.env.VUE_APP_AWS_REGION,
        userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_CLIENT_ID,
    },
})

dayjs.extend(weekOfYear)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)

elementClosest(window)

Vue.use(VueCroppie)
Vue.use(PortalVue)
Vue.use(Meta)
Vue.use(VueConfetti)

require('styles/main.scss')

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

const embeds = require.context('embeds')
embeds.keys().forEach(embeds)
Userpilot.initialize(process.env.VUE_APP_USER_PILOT_TOKEN) //`appToken` should be replaced with your userpilot appToken.

SessionActivityService.init(Router)
if (AuthService.isLoggedIn()) {
    SessionActivityService.start()
}

new Vue({
    config: {
        productionTip: false,
        performance: process.env.NODE_ENV === 'developement',
    },
    router: Router,
    store: Store,
    i18n: I18n,
    template: '<router-view></router-view>',
}).$mount('#app')
